import type { TKinds, TSizes, TWidths, TThemes } from './models';

export const DEFAULT_TYPE = 'button';

export const DEFAULT_SIZE = 'l';
export const SIZES: TSizes[] = ['s', 'm', 'l', 'xl', 'xxl'];

export const DEFAULT_THEME = 'white';
export const THEMES: TThemes[] = ['white', 'blue'];

export const WIDTHS: TWidths[] = ['250', 'full', '47-pc', 'auto'];

export const DEFAULT_KIND = 'red';
export const KINDS: TKinds[] = [
    'red',
    'stroke',
    'grey',
    'pseudo',
    'blue',
    'translucent',
    'webviewblack',
];
